import Render   from './Filter/Render.es6';
import Layout   from './Filter/Layout.es6';
import Bind     from './Filter/Bind.es6';

(() => {
    class Filter extends App.Component {
        constructor(container) {
            super(container);
            /* Layout */
            this.Interface.Observer.register(this);

            /* Initialize Search */
            this.Layout = new Layout(this);

            /* Initialize Filter */
            this.filter = {
                'url':      true,   /* If we base our filter in the url */
                'enabled':  {},     /* All enabled Filter Items for this brand */
                'active':   {},     /* All selected Filter Items for this instance */
            };
            this
                .build()
                .update()
            ;
            new Bind(this);
        }

        /* Constants */
        get Interface() { return this._interface || App.Interface.Search }
        get Mask()      { return App.Interface.Mask }
        get Render()    { return this._render || (this._render = new Render(this)) }

        set content(content) {
            this.Layout.content.innerHTML = content;
        }

        setInterface(Interface) {
            this.Interface.Observer.remove(this);
            this._interface = Interface;
            this.Interface.Observer.register(this);
            return this;
        }

        get count() {
            return this.container.querySelector('.filter-count');
        }
        set count(count) {
            this.count.innerHTML = count < this.Interface.total ?
                App.Template.parseString(__('INTERFACE.SEARCH.ITEMS'), {'count': count})
                :
                __('INTERFACE.SEARCH.ALL.ITEMS');
        }

        get(key) {
            return this.Interface.filters[key];
        }

        getSiblingKeys(key) {
            const parent = this.get(key).group;
            const r = [];
            for (const k in this.Interface.filters) {
                if (this.Interface.filters[k].group === parent && this.Interface.filters[k].key !== key) {
                    r.push(this.Interface.filters[k].key);
                }
            }
            return r;
        }

        /* Filters */
        setFilter() {
            // Change Order Selector
            this.container.querySelector('select[name=sort] [value="' + this.Interface.sort.by + '"]').selected = true;
            this.Layout.unselectFilters();
            this.Interface.Filter.selected
                .forEach(filter => this.Layout.activateFilterItem(filter));
        }

        build() {
            let groups  = {};
            let content = '';
            for (let key in this.Interface.filters) {
                let item = this.Interface.filters[key];
                if (groups[item.group] === undefined) groups[item.group] = '';
                groups[item.group]+= this.Render.item(key, item.label, this.Interface.filterGroups[item.group].unique);
            }
            for (let key in this.Interface.filterGroups) {
                let group = this.Interface.filterGroups[key];
                content+= this.Render.group(key, group.label, groups[key]);
            }
            this.content = content;
            return this;
        }

        update() {
            super.update(() => {
                this.count = this.Interface.count;
                this.setFilter();
                this.Layout.hideAllFilterItems();
                this.Interface.Filter.visible.forEach(filter => this.Layout.showFilterItem(filter));
                /* Hide Filter Groups if there are no active Items */
                this.Layout.showFilterGroups();
                window.gaTrackView();
            });
            return this;
        }
    }
    App.Components.register('.overview-filter', Filter);
})();
